
const config = { attributes: false, childList: true, subtree: true };

// Callback function to execute when mutations are observed
const callback = (mutationList, observer) => {
    const allAccessDeniedMessages = document.querySelectorAll('.bss-lock-price-access-deniend-5208');
    allAccessDeniedMessages.forEach(message => {
        if (message.href != 'https://accentdistributing.com/pages/become-a-dealer#target') {
            message.href = '/pages/become-a-dealer#target'
            message.target = '_blank'
            const newNode = message.cloneNode(true);
            newNode.innerHTML = 'Contact us';
            newNode.href = '/pages/contact-us';
            newNode.classList.remove('bss-lock-price-access-deniend-5208')
            const brTag = document.createElement('br');
            const accessDeniedMessage = document.createElement('span');
            accessDeniedMessage.innerHTML = 'Already a dealer and needing access? '
            console.log(brTag, accessDeniedMessage, newNode, message)
            message.parentElement.appendChild(brTag);
    
            message.parentElement.appendChild(accessDeniedMessage);
            message.parentElement.appendChild(newNode);

        }
    });
};

// Create an observer instance linked to the callback function
const observer = new MutationObserver(callback);

// Start observing the target node for configured mutations
observer.observe(document.body, config);

